export default __webpack_public_path__ + "static/media/gallery_02.535655a2.jpg";